import React from "react";
import "../assests/CSS/ArticleComp1.css";
import { articleData } from "./data";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const ArticleComp1 = () => {
  return (
    <div className="articlecomp1">
      {/* Overlay */}
      <div className="overlay"></div>

      {/* Content */}
      <div className="articlecomp1-content">
        <h1 className="articlecomp1-title">{articleData.title}</h1>
        <Link to={articleData.buttonLink}>
          <button className="articlecomp1-btn">
            <span>{articleData.buttonText}</span>
            <ArrowRight className="arrow" />
          </button>
        </Link>
      </div>
    </div>
  );
};

export default ArticleComp1;
